import type { Moment } from 'moment/moment';
import moment from 'moment';

export const formatDate = (date: Moment) => date.format('YYYY-MM-DD');

export const dateToString = (timestamp?: string) => moment(timestamp).format('DD.MM.YYYY');

export const timestampToString = (timestamp?: string | null) => moment(timestamp).format('DD.MM.YYYY HH:mm:ss');
